import { useEffect, useState } from "react";
import api from "../../lib/api";
import { WhySection, TestimonialsSection, FinalCta } from "../../components/sections";
import { Reveal } from "../../components/Reveal";

export default function About() {
  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => {
    api.get("/content/testimonials").then(({ data }) => setTestimonials(data));
  }, []);
  return (
    <>
      <section className="pt-36 pb-16 px-5 sm:px-8" data-testid="about-page">
        <div className="max-w-4xl mx-auto text-center">
          <Reveal>
            <span className="text-xs font-bold uppercase tracking-[0.18em] text-brand-orange">About EasyVideo</span>
            <h1 className="mt-3 font-heading font-extrabold text-4xl sm:text-6xl text-brand-purpleDeep leading-tight">
              We make the whole process easy.
            </h1>
            <p className="mt-6 text-lg text-brand-purpleDeep/60 leading-relaxed">
              EasyVideo is a New Zealand video production company on a simple mission: help businesses create professional
              video content without the complexity, jargon and stress that usually comes with it. You bring the idea —
              we handle everything from concept to final cut, and keep you in the loop the whole way through.
            </p>
          </Reveal>
        </div>
      </section>

      <WhySection />
      <TestimonialsSection testimonials={testimonials} />
      <FinalCta />
    </>
  );
}
